import { getSuffix } from "../common/deliveryDate";

/**
 * @param {string|number|Date} [dt]
 * @returns {string}
 */
export function dateAndTimeFormatWithoutDay(dt) {
  if (!dt) {
    return "";
  }
  const parsed = new Date(dt);
  if (Number.isNaN(parsed.getTime())) {
    return String(dt);
  }
  return parsed.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * @param {string|number} [ms]
 * @returns {string}
 */
export function getDateFromMilliseconds(ms) {
  if (!ms) {
    return "";
  }
  const parsed = new Date(ms);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }
  return parsed.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

/**
 * @param {string} [time]
 * @returns {string}
 */
export function convert24To12Hours(time) {
  if (!time) {
    return "";
  }
  const convertedTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  if (time.length > 1 && convertedTime.length > 1) {
    const parts = [...convertedTime];
    parts.shift();
    parts.pop();
    parts[3] = +parts[0] < 12 ? " AM" : " PM";
    parts[0] = +parts[0] % 12 || 12;
    return parts.join("");
  }
  return String(time);
}

/**
 * @param {string|number|Date} [value]
 * @returns {string}
 */
export function formatEstimatedDeliveryHeading(value) {
  if (!value) {
    return "";
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return String(value);
  }
  const day = parsed.getDate();
  const month = parsed.toLocaleString("en-IN", { month: "short" });
  const year = parsed.getFullYear();
  return `${day}${getSuffix(day)} ${month} ${year}`;
}
